<template>
  <DialogTemplateToolkit
    class-name="valid-tender-copy"
    :dialog="show_edit"
    :disabled="load_file"
    first_btn="Common.Apply"
    :loading="load_comment || load_file"
    :title="$t('Tenders.AddAdditionalConditions')"
    @apply="applyModalResult"
    @close="cancel">
    <template #activator-btn>
      <sBadge
        color="red"
        data-qa="file-badge"
        dot
        :offset-x="28"
        :offset-y="5"
        overlap
        :value="files.length">
        <sButton
          class="align-center"
          :disabled="disabled"
          :small="small"
          type="text"
          @click.stop="show_edit = true">
          <sIcon
            class="mr-3"
            :type="edit ? 'edit' : 'plus-circle'"/>
          {{ edit ? $t('Tenders.EditConditions') : $t('Tenders.AddConditions') }}
        </sButton>
      </sBadge>
    </template>
    <template #card-text>
      <div>
        <div class="h6-text mb-4">
          {{ $t('Tenders.InformationWillBeAddedToLetter') }}
        </div>

        <sFormItem
          ref="formItem"
          :error="text && text.length > 4000 ? $t('Validate.maxLength', {number: 4000, type: $tc('Common.characters', 10) }) : null"
          :label="$t('Tenders.AdditionalConditionsFromOrganizer')">
          <sInput
            clearable
            data-qa="offer-additional-conditions"
            :disabled="load_comment"
            :max-length="4000"
            max-rows="20"
            :placeholder="$t('Common.EnterText')"
            rows="4"
            show-word-limit
            type="textarea"
            :value.sync="text"/>
        </sFormItem>

        <sCheckbox
          v-model="comment_for_all_tenders"
          class="mt-3"
          data-qa="offer-document-comment-for-all-tenders"
          :disabled="load_comment">
          <span class="h8-text black--text mb-1">{{ $t('Tenders.COConditionForAllNextTenders') }}</span>
        </sCheckbox>
      </div>
      <div
        class="mt-4 p-4">
        <ImportBlock
          :create-file-handler="createFileHandler"
          :disabled="load_file"
          file_size="10"
          :files="files"
          :files-types="['jpg', 'jpeg', 'png', 'gif', 'webp']"
          inline-style="width: 100%"
          :multiple="false"
          @deleteFile="deleteFile"
          @update:files="updateFiles"/>
      </div>
    </template>
  </DialogTemplateToolkit>
</template>
<script>
import ImportBlock from 'components/common/blocks/ImportBlock.vue'
import DialogTemplateToolkit from 'components/common/dialogs/DialogTemplateToolkit.vue'
import SmarttenderApi from '@/api/smarttenderApi'
import textFunctions from 'mixins/textFunctions'

import { CommercialOfferDocumentFile } from '@/types/commonFile.js'

const api = new SmarttenderApi()

export default {
  name: 'addCOAdditionalConditions',
  mixins: [textFunctions],
  data() {
    return {
      show_edit: false,
      load_comment: false,
      load_file: false,
      conditions: '',
      text: '',
      comment_for_all_tenders: false,
      files: [],
    }
  },
  created() {
    api.getCommercialOffer(this.tender_id)
      .then(res => {
        if (res) {
          this.text = this.conditions = this.$_escapeHtml(res.organizerComment)
          this.files = res.organizerAdditionalImage ? [res.organizerAdditionalImage] : []
        }
      })
  },
  computed: {
    edit() {
      return !!this.conditions?.length
    },
    tender_id() {
      return +this.$route?.query?.id
    }
  },
  methods: {
    createFileHandler(file) {
      return new CommercialOfferDocumentFile(
        this.tender_id,
        null,
        null,
        file,
        file.name || file.title,
        file.size
      )
    },
    async updateFiles(files) {
      if (this.files?.length) {
        await this.deleteFile({file: this.files[0]}, false)
      }
      const newFile = files.find(file => !file.id)
      if (!newFile) {
        return
      }
      this.load_file = true
      newFile.uploadFile()
        .then((res) => {
          this.$set(this, 'files', res.data)
          this.$emit('updateOffer')
        })
        .catch((res) => {
          this.$notice.error({
            title: this.$t('Common.ErrorTitle'),
            showClose: true,
            progress: true,
          })
          this.$log_error(res)
          this.files = []
        })
        .finally(() => {
          this.load_file = false
        })
    },
    async deleteFile(deleteProps, sendEvent = true) {
      this.load_file = true
      await new CommercialOfferDocumentFile(
        this.tender_id,
        deleteProps.file.id,
        null,
        deleteProps.file,
        deleteProps.file.title,
        deleteProps.file.size
      ).deleteFile()
        .then(() => {
          this.files = []
          if (sendEvent) {
            this.$emit('updateOffer')
          }
        })
        .catch((res) => {
          this.$notice.error({
            title: this.$t('Common.ErrorTitle'),
            showClose: true,
            progress: true,
          })
          this.$log_error(res)
          this.files.push(deleteProps.file)
        })
        .finally(() => {
          this.load_file = false
        })
      //this.fileModal.splice(index, 1)
    },
    clear() {
      this.text = this.$_escapeHtml(this.conditions)
      this.comment_for_all_tenders = false
    },
    cancel() {
      this.clear()
      this.show_edit = false
    },
    async applyModalResult() {
      this.load_comment = true
      let success
      const escapeText = this.$_escapeHtml(this.text)

      if (escapeText.length > 4000) {
        this.$notice.error({
          title: this.$t('Common.ErrorTitle'),
          message: this.$t('Common.MaxCharacters'),
          showClose: true,
          progress: true,
        })
        this.load_comment = false
        return
      }

      if (this.comment_for_all_tenders) {
        await api.organisatorComment( escapeText )
      }
      if ( escapeText != this.conditions) {
        success = await api.commercialOfferComment(this.tender_id, escapeText)
        if (success) {
          this.$emit('updateOffer')
          this.show_edit = false
          this.conditions = escapeText
        }
      } else {
        this.show_edit = false
      }
      this.load_comment = false
    }
  },
  components: {
    DialogTemplateToolkit,
    ImportBlock
  },
  props: {
    small: Boolean,
    disabled: Boolean,
  }
}
</script>
